<template>
  <dropdown
    :align="align"
    :active="menuOpen"
    @close="menuOpen = false"
  >
    <pill
      v-if="showPill"
      sortable
      :tooltip="activeOption ? activeOption.tooltip : tooltip"
      @click.native="menuOpen = !menuOpen"
    >
      {{ activeOption ? activeOption.label : label }}
    </pill>

    <template #menu>
      <dropdown-menu
        :options="options"
        @select="handleSelect"
      />
    </template>
  </dropdown>
</template>

<script>
import Dropdown from './Dropdown';
import DropdownMenu from './DropdownMenu';
import Pill from './Pill';

export default {
  components: {
    Dropdown,
    DropdownMenu,
    Pill,
  },

  props: {
    value: [String, Number, Object],
    options: Array,
    label: String,
    tooltip: String,
    align: {
      type: String,
      default: 'right',
    },
  },

  data() {
    return {
      localValue: this.value,
      menuOpen: false,
    };
  },

  watch: {
    value(value) {
      this.localValue = value;
    },
  },

  computed: {
    activeOption() {
      return this.options.find(({ value }) => value === this.localValue);
    },

    showPill() {
      return this.activeOption || this.label;
    },
  },

  methods: {
    handleSelect(value) {
      this.menuOpen = false;
      this.localValue = value;
      this.$emit('input', value);
    },
  },
};
</script>
